import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FlexContainer, isEmpty, Button, TitleH4 } from 'heliocor-ui'
import styled from 'styled-components'

import { SET_STEP_INDEX } from '../../store/cafe/actionTypes'

const PostErrorsButton = () => {

    const { t } = useTranslation()
    const errors = useSelector(state => state.party.postErrors)
    const fields = useSelector(state => state.settings.customFields)
    const stepsList = useSelector(state => state.navigation.stepsList)

    const dispatch = useDispatch()

    const setStepIndex = useCallback(
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (stepIndex, err) => dispatch({ type: SET_STEP_INDEX, stepIndex }),
        [dispatch]
    )

    const getStepIndex = () => {
        const errIds = errors.map(e => e.field)
        for (let cat in fields) {
            const found = fields[cat].find(f => errIds.includes(f.id))
            if (found) return stepsList.findIndex(s => s === cat)
        }
        if (errors.find(e => e.identifier)) {
            return stepsList.findIndex(s => s === 'STRUCTURE')
            }
        return 1
    }

    return isEmpty(errors)
        ? <FlexContainer minHeight="3rem" ></FlexContainer>
        :
        <FlexContainer justifyContent='center' alignItems='center' padding="0 1rem 2rem" column>
            <Info>Some errors have been found. Please click here to view and correct these issues.</Info>
            <Button
                type="error"
                value={t('button.correct')}
                onClick={() => setStepIndex(getStepIndex())}
            />
        </FlexContainer>
}

const Info = styled(TitleH4)`
    text-transform: none;
    font-weight: 400;
`

export { PostErrorsButton }